import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_console/settings/organizations")({
  component: Outlet,
});
